import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { DuplicatedNfError } from "../../domain/errors/duplicated-nf-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { DeleteBreakageReport } from "../../domain/usecases/delete-brekage-report";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbDeleteBrekageReport implements DeleteBreakageReport {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async delete(id: number): Promise<void> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "delete",
      body: { id },
    });

    if (res.statusCode > 199 && res.statusCode < 300) {
      return res.body;
    } else {
      if (res.statusCode === 401 || res.statusCode === 403) {
        throw new UnauthorizedError();
      }
      throw new Error(
        res.body.error.message ||
          res.body.error.data.message ||
          "Ocorreu um erro. Tente novamente em breve"
      );
    }
  }
}
